import axios from './api';

export const getList = () => {
  alert(1);
  return axios.request({
    method: 'GET',
    url: '/cgi-bin/service/get_suite_token',
  });
};

export const getUserInfo = (params: any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getLoginUserId',
    params,
  })
);
